import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useForm } from "../hooks/useForm";
import { ambiente_produccion, loginApi, produccion } from "../utils/Datos";
import { login } from "../reducers/userSlice";
import logo_pena from "../assets/logos/logo_pena.png";

import { ClaveUnicaLogin } from "../components/Otros/ClaveUnicaLogin";

export const LoginScreen = () => {
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const [form, updateValue] = useForm({ run: "", password: "" });
  const { run, password } = form;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams, setSearchParams] = useSearchParams();

  const errorAuth = searchParams.get("errorAuth");
  const ambiente_productivo = ambiente_produccion;
  const handleSubmit = (e) => {
    e.preventDefault();

    setError("");
    setCargando(true);

    loginApi(run.replace(".", ""), password).then((respuesta) => {
      if (respuesta.status === true) {
        dispatch(
          login({
            user: {
              name: respuesta.datos.name,
              id_officer: respuesta.datos.id_officer,
              username: respuesta.datos.username,
              run: respuesta.datos.run,
              email: respuesta.datos.email,
              roles: respuesta.datos.roles_qualifications,
              fecha_login: Date.now(),
            },
            loggedIn: true,
          })
        );
        navigate("/home");
      } else {
        setError(respuesta.errores ?? "Ocurrió un error");
      }
      setCargando(false);
    });
  };

  return (
    <div className="d-flex flex-column flex-root" id="kt_app_root">
      <div className="d-flex flex-center flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-center p-12">
          <div className="bg-body d-flex flex-center rounded-4 w-md-600px p-10">
            <div className="w-md-400px">
              {errorAuth === "timeout" ? (
                <div className="alert alert-info pt-4 pb-4" role="alert">
                  <strong>Atención,</strong> hemos cerrado su sesión por
                  inactividad
                </div>
              ) : (
                <></>
              )}
              <form
                className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
                id="kt_sign_in_form"
                onSubmit={handleSubmit}
              >
                <div className="text-center mb-11">
                  <img src={logo_pena} className="mt-3 mb-4" width="200"/>
                  <div className="text-gray-500 fw-semibold fs-6">
                  Inicio de sesión Calificaciones digitales
                    {
                      !ambiente_productivo ? <h4 className="text-warning"><i className="fas fa-exclamation-triangle mr-2 text-warning"></i>AMBIENTE DE DESARROLLO</h4>: <></>
                    }
                  </div>
                  { /*
                  <ul>
                    <li>Administrador: 17098908-2</li>
                    <li>Admin municipal: 10311236-2</li>
                    <li>Precalificador: 08777925-4</li>
                    <li>Secretario JC: 07187016-2</li>
                    <li>Funcionario: 13929089-5</li>
                  </ul>
                  */}
                </div>

                <div className="fv-row mb-8 fv-plugins-icon-container">
                  <input
                    type="text"
                    placeholder="Rut"
                    name="run"
                    autoComplete="off"
                    className="form-control bg-transparent"
                    value={run}
                    onChange={updateValue}
                  />
                  <small className="text-muted"><i className="ki-solid ki-information text-warning"></i>Ingresar su rut sin puntos y con guión. Si el rut es menor a 10 millones anteponer un 0 EJ: 12345678-k 08123456-0</small>
                  <div className="fv-plugins-message-container invalid-feedback" />
                </div>
                <div className="fv-row mb-3 fv-plugins-icon-container">
                  <input
                    type="password"
                    placeholder="Contraseña"
                    name="password"
                    autoComplete="off"
                    className="form-control bg-transparent"
                    value={password}
                    onChange={updateValue}
                  />
                  <div className="fv-plugins-message-container invalid-feedback" />
                </div>
                <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                  <div />
                  <a
                    href="/metronic8/demo1/../demo1/authentication/layouts/overlay/reset-password.html"
                    className="link-primary d-none"
                  >
                    ¿Olvidaste tu contraseña?
                  </a>
                  <small className="text-muted">Versión 1.0.6</small>
                </div>
                <div className="d-grid mb-10">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={cargando}
                    onClick={handleSubmit}
                  >
                    <span className="indicator-label">
                      {cargando ? "Iniciando sesión..." : "Entrar"}
                    </span>
                  </button>
                  {error != "" ? (
                    <span className="text-danger">{error}</span>
                  ) : (
                    <></>
                  )}
                  <div className="text-center">
                    <p className="mt-4 text-muted">También puedes ingresar con ClaveÚnica</p>
                    <ClaveUnicaLogin />
                  </div>
                  
                </div>
                <div />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
